import { Grid2 } from "@mui/material";
import CarePlanWidget from "../../../features/care-plan-widget/CarePlanWidget";

const CarePlanGrid = () => (
  <Grid2 container spacing={2}>
    <Grid2 size={{ xs: 12 }} display="flex" justifyContent={"center"}>
      <CarePlanWidget />
    </Grid2>
  </Grid2>
);

export default CarePlanGrid;
